export const MOBILE_MENU_FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';

export type MobileTabIndexBackupKey =
  | 'mobileMenuTabindexBackup'
  | 'mobileMenuDrawerBottomBackup'
  | 'mobileNavMainBackup';

const TABINDEX_RESTORE_SELECTOR: Record<MobileTabIndexBackupKey, string> = {
  mobileMenuTabindexBackup: '[data-mobile-menu-tabindex-backup]',
  mobileMenuDrawerBottomBackup: '[data-mobile-menu-drawer-bottom-backup]',
  mobileNavMainBackup: '[data-mobile-nav-main-backup]',
};

export function disableSubtreeTabIndex(
  root: HTMLElement,
  backupKey: MobileTabIndexBackupKey,
): void {
  const elements = Array.from(
    root.querySelectorAll<HTMLElement>(MOBILE_MENU_FOCUSABLE_SELECTOR),
  );
  for (const el of elements) {
    if (el.dataset[backupKey] !== undefined) {
      continue;
    }
    el.dataset[backupKey] = el.getAttribute('tabindex') ?? '';
    el.tabIndex = -1;
  }
}

export function restoreSubtreeTabIndex(
  root: HTMLElement,
  backupKey: MobileTabIndexBackupKey,
): void {
  const toRestore = Array.from(
    root.querySelectorAll<HTMLElement>(TABINDEX_RESTORE_SELECTOR[backupKey]),
  );
  for (const el of toRestore) {
    const backup = el.dataset[backupKey];
    delete el.dataset[backupKey];
    if (backup === undefined || backup === '') {
      el.removeAttribute('tabindex');
    } else {
      el.setAttribute('tabindex', backup);
    }
  }
}
